



import StoreListComponent from "@/components/admin/store/storeListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreListPage",
  components: {
    StoreListComponent,
  },
})
export default class StoreListPage extends Vue {}
